import { OrdStatusEnum } from '../types/types';

export const isOrderPending = (ordStatus: OrdStatusEnum) =>
  Boolean(
    ordStatus === OrdStatusEnum.PendingCancel ||
    ordStatus === OrdStatusEnum.PendingReplace ||
    ordStatus === OrdStatusEnum.PendingNew
  );
